import React from "react";
import { Form } from "react-bootstrap";

interface TextInputProps {
  label: string;
  name: string;
  type?: string;
  value: string | number;
  required?: boolean;
  placeholder?: string;
  onChange: (name: string, value: string) => void;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  type = "text",
  value,
  required = false,
  placeholder = "",
  onChange,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Form.Control
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={(e) => onChange(name, e.target.value)}
      />
    </Form.Group>
  );
};

export default TextInput;
